<template>
  <div>
    <app-header />
    <mpn-page-title :title="pageTitle" />

    <!-- S : main -->
    <main class="a-service-main renewal_floating-type">
      <!-- S : 컨텐츠 영역 -->
      <div class="a-service-container">
        <state-info :order-result="orderResult"/>
        <div class="box-order-content">
          <!-- S : 배송정보 -->
          <delivery-info :order-result="orderResult" :hybris-order-keys="orderResult.orders"/>
          <!-- E : 배송정보 -->
        </div>
        <!-- S : 오른쪽 -->
        <right-info
          :pack-info="packInfo"
          :price-info="priceInfo"
          :delivery-fee="deliveryFee"
          :package-fee="packageFee"
        />
        <!-- E : 오른쪽 -->
        <div class="box-order-content">
          <!-- S : 주문제품 보기 -->
          <order-products :order-result="orderResult" :is-group-order="isGroupOrder"/>
          <!-- E : 주문제품 보기 -->
        </div>
      </div>
    <!-- E : 컨텐츠 영역 -->

    <!-- S : 모바일 플로팅
    <div class="box_mobile-floating">
        <button type="button" class="btn_square-a btn_payment-type">
			<span class="txt_total-price">
				총<strong class="txt_point-color">300,000</strong>원
			</span>
            <span class="txt_point-payment">결제하기</span>
        </button>
    </div>
    -->
    </main>
    <!-- E : main -->

    <app-footer />
  </div>
</template>

<script>
import {
  DELIVERY_FEE_SKU,
  PACKAGE_WRAPPING_FEE_SKU,
} from '@/utils/constants';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
import StateInfo from './partial/StateInfo.vue';
import DeliveryInfo from './partial/DeliveryInfo.vue';
import RightInfo from './partial/RightInfo.vue';
import OrderProducts from './partial/OrderProducts.vue';

export default {
  name: 'CompleteOrder',
  components: {
    AppHeader,
    AppFooter,
    StateInfo,
    DeliveryInfo,
    RightInfo,
    OrderProducts,
  },
  props: {
    orderResult: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      pageTitle: '주문/결제',
    };
  },
  computed: {
    isGroupOrder() {
      return this.orderResult.group != null && this.orderResult.group === 'Y' ? true : false
    },
    priceInfo() {
      return {
        totalBv: this.orderResult.total_bv,
        totalPv: this.orderResult.total_pv,
        totalPrice: this.orderResult.total_price,
      };
    },
    deliveryFee() {
      let item;
      // 그룹오더 여부에 따라 배송비 분기처리
      if(this.isGroupOrder){
         item = this.orderResult.group_product_info[0].product_info
        .find((n) => n.item_sku === DELIVERY_FEE_SKU);
      } else {
        item = this.orderResult.product_info
        .find((n) => n.item_sku === DELIVERY_FEE_SKU);
      }

      if (item) {
        return item.total_price;
      }
      return 0;
    },
    packageFee() {
      // 그룹여부 여부에 따라 포장비 분기처리
      if(this.isGroupOrder){
        let totalWrappingPrice = 0;
        this.orderResult.group_product_info.forEach(product => {
          const item = product.product_info.find((n) => n.item_sku === PACKAGE_WRAPPING_FEE_SKU);
          if(item) {
            totalWrappingPrice += item.total_price;
          }
        });
        return totalWrappingPrice;
      } else {
        const item = this.orderResult.product_info.find((n) => n.item_sku === PACKAGE_WRAPPING_FEE_SKU);
        if (item) {
          return item.total_price;
        }
        return 0;
      }
    },
    packInfo() {
      return this.isGroupOrder ? this.orderResult.group_product_info : [this.orderResult];
    }
  },
  methods: {
  },
  created() {
    this.$store.dispatch('resetOrderInfo');
  }
};
</script>
